export const getIsOnePayFlow = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('checkoutmethod') !== 'ecommapi'
}
